const applicantDetailsDictionary = {
  verifyPan: () => "api/v1/applicant/verify-pan",
  aadhaarApplication: () => "api/v1/applicant/create-app-via-aadhaar-phone",
  digilockerApplication: () => "api/v1/applicant/verify-aadhaar",
  verifyAadhaarApplication: () => `api/v1/applicant/eaadhaar-details`,
  createApplicant: () => "api/v1/applicant/create",
  applicantIssueFile: (trackingId: string) => `api/v1/applicant/issued-files-list/${trackingId}`,
  getLeadDetails: () =>  `api/v1/partner/get-lead-details`,
  updateCoApplicantFormData: () => "api/v1/applicant/update-coapplicant-formData"
};
export default applicantDetailsDictionary;
